import script from "./InventIdea.vue?vue&type=script&setup=true&lang=js"
export * from "./InventIdea.vue?vue&type=script&setup=true&lang=js"

import "./InventIdea.vue?vue&type=style&index=0&id=503eda49&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-503eda49"]])

export default __exports__